import { Predicate } from "@angular/core";
import { of } from "rxjs";

export const retiredLocalStorageKeys: Array<Predicate<string>|string> = [    
    'countries',
    'schools',
    'school-subjects',
    'visa-subclasses',
    'oshc-providers',
    'english-testtype',
    'iec-durations',
    'relationships',
    'years-of-entry',
    'durations',
    'terms'
];

export const retireUnwantedLocalStorageKeys  = () => {
    
    console.log('INSIDE APP INITIALIZER >> RETIRE UNWANTED LOCAL STORAGE KEYS');

    retiredLocalStorageKeys.forEach(obj => {
        if (typeof obj === 'string') {
            localStorage.removeItem(obj);
        } else if (typeof obj === 'function') {            
            const allLocalStorageKeys = Object.keys(localStorage);
            allLocalStorageKeys.filter(obj as Predicate<string>).forEach(key => localStorage.removeItem(key));
        }
    });

    console.log('INSIDE APP INITIALIZER >> RETIRED UNWANTED LOCAL STORAGE KEYS');

    return of(true).toPromise();
}